import { GraduationCap } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { DateField } from '@/components/ui/date-field'
import { Input } from '@/components/ui/input'
import { Modal } from '@/components/ui/modal'
import { Select } from '@/components/ui/select'
import { useCreateTraining } from '../../api'
import { todayIso } from '../../lib/fileExport'
import { Field, ModalFooter } from './Field'
import { apiErrorMessage } from '@/i18n'

const SAGLAYICILAR = ['Udemy', 'Coursera', 'İç Eğitim', 'LinkedIn Learning']

export function EgitimAtaModal({ personelId, onClose }: { personelId: string; onClose: () => void }) {
  const { t } = useTranslation()
  const [ad, setAd] = useState('')
  const [saglayici, setSaglayici] = useState(SAGLAYICILAR[0] ?? '')
  const [tarih, setTarih] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const create = useCreateTraining()
  const req = (v: string) => (submitted && !v.trim() ? t('hr.personel.actions.required') : undefined)

  const submit = () => {
    setSubmitted(true)
    if (!ad.trim() || !tarih) return
    create.mutate(
      { employeeId: personelId, name: ad.trim(), provider: saglayici, date: tarih },
      {
        onSuccess: () => {
          toast.success(t('hr.personel.actions.egitim.created', { name: ad.trim() }))
          onClose()
        },
        onError: (error) => toast.error(apiErrorMessage(error)),
      },
    )
  }

  return (
    <Modal
      open
      onOpenChange={(v) => !v && onClose()}
      icon={<GraduationCap />}
      title={t('hr.personel.actions.egitim.title')}
      description={t('hr.personel.actions.egitim.hint')}
      onSubmit={(e) => {
        e.preventDefault()
        submit()
      }}
      footer={<ModalFooter onCancel={onClose} />}
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <Field id="egt-ad" label={t('hr.personel.actions.egitim.ad')} error={req(ad)} className="sm:col-span-2">
          <Input id="egt-ad" className="h-10 rounded-xl" value={ad} onChange={(e) => setAd(e.target.value)} aria-invalid={!!req(ad)} />
        </Field>
        <Field id="egt-sag" label={t('hr.personel.actions.egitim.saglayici')}>
          <Select id="egt-sag" size="lg" className="w-full rounded-xl" value={saglayici} onChange={setSaglayici} options={SAGLAYICILAR.map((s) => ({ value: s, label: s }))} />
        </Field>
        <Field id="egt-tarih" label={t('hr.personel.actions.egitim.tarih')} error={req(tarih)}>
          <DateField id="egt-tarih" className="h-10 rounded-xl" value={tarih} min={todayIso()} onChange={setTarih} aria-invalid={!!req(tarih)} />
        </Field>
      </div>
    </Modal>
  )
}
